import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";

const input = "mt-2 w-full bg-white/5 border border-white/15 focus:border-[#FF3B30] outline-none px-4 transition-colors";
const Field = ({ label, children }) => <label className="block"><span className="font-mono text-xs uppercase tracking-widest text-neutral-400">{label}</span>{children}</label>;

export default function Contact() {
  const { user } = useAuth();
  const [f, setF] = useState({ name: user?.name || "", email: user?.email || "", subject: "", message: "" });
  const [state, setState] = useState("idle");
  const on = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setState("sending");
    try { await api.post("/contact", f); setState("sent"); }
    catch (err) { toast.error(formatApiError(err)); setState("idle"); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12" data-testid="contact-page">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF3B30] font-semibold mb-2">Support</p>
      <h1 className="font-display font-black uppercase tracking-tight text-4xl sm:text-5xl">Contact us</h1>
      <p className="text-neutral-400 mt-4 max-w-xl">Order questions, returns, sizing, digital access issues — send us a message and the ABS crew will get back to you. Include your order number if you have one.</p>
      {state === "sent" ? (
        <div data-testid="contact-success" className="mt-10 border border-emerald-500/30 bg-emerald-500/10 p-8 flex gap-4 items-start">
          <CheckCircle2 className="w-6 h-6 text-emerald-400 shrink-0" />
          <div>
            <p className="font-display uppercase font-black text-xl">Message received</p>
            <p className="text-sm text-neutral-300 mt-1">Thanks, {f.name}. We'll reply to {f.email} as soon as we can.</p>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="contact-form" className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5 border border-white/10 bg-[#121215] p-6 sm:p-8">
          <Field label="Name"><input data-testid="contact-name-input" required maxLength={80} className={`${input} h-12`} value={f.name} onChange={on("name")} /></Field>
          <Field label="Email"><input data-testid="contact-email-input" type="email" required className={`${input} h-12`} value={f.email} onChange={on("email")} /></Field>
          <div className="sm:col-span-2"><Field label="Subject (optional)"><input data-testid="contact-subject-input" maxLength={120} className={`${input} h-12`} value={f.subject} onChange={on("subject")} placeholder="Order #ABC12345 — return request" /></Field></div>
          <div className="sm:col-span-2"><Field label="Message"><textarea data-testid="contact-message-input" required minLength={10} maxLength={4000} className={`${input} h-40 py-3`} value={f.message} onChange={on("message")} /></Field></div>
          <button data-testid="contact-submit" disabled={state === "sending"} className="sm:col-span-2 h-12 bg-[#FF3B30] hover:bg-[#E02E24] text-white font-display uppercase font-black tracking-wider disabled:opacity-60">
            {state === "sending" ? "Sending..." : "Send message"}
          </button>
        </form>
      )}
    </div>
  );
}
